
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';

  export default defineComponent({
    name: 'users-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref<any>({
        email: '',
        phone: '',
        name: '',
        member_type: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = async () => {
        await store.dispatch(Actions.UPDATE_USERS_FILTER, selectedItems.value);
        emit('type-selected', selectedItems.value);
      };

      const onReset = async () => {
        selectedItems.value = {
          phone: '',
          email: '',
          name: '',
          member_type: '',
        };
        await store.dispatch(Actions.UPDATE_USERS_FILTER, selectedItems.value);
        emit('reset', selectedItems.value);
      };

      const filter = computed(() => store.getters.getUsersFilter || {});
      onMounted(() => {
        if (filter.value?.phone) selectedItems.value.phone = filter.value.phone;
        if (filter.value?.email && filter.value.email !== 'undefined')
          selectedItems.value.email = filter.value.email;
        if (filter.value?.name && filter.value.name !== 'undefined')
          selectedItems.value.name = filter.value.name;
        if (
          filter.value?.accountType &&
          filter.value.accountType !== 'undefined'
        )
          selectedItems.value.accountType = filter.value.accountType;
      });

      return { selectedItems, onSubmit, onReset, translate };
    },
  });
